import { URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';

import { AuthHttp } from 'angular2-jwt';
import 'rxjs/add/operator/toPromise';

import { environment } from '../../../../environments/environment';

export type SituacaoItem =
  'NAO_VERIFICADO' | 'COM_PENDENCIA' | 'SEM_PENDENCIA' | 'ATUALIZADO_APOS_CORRECAO';

export interface ContadoresAnalise {
  total: number;
  naoVerificados: number;
  comPendencia: number;
  semPendencia: number;
  atualizadosAposCorrecao: number;
  /** Conferência exibida: tem de ser igual a `total`. */
  somaDasSituacoes: number;
  fecha: boolean;
}

export interface ItemAnalise {
  id: number;
  numeroOb: string;
  tipo: string;
  valor: number;
  dataTransferencia: string;
  /** O texto como está no banco, que separa "ninguém pediu" de "pediram e ninguém analisou". */
  statusGravado: string;
  situacao: SituacaoItem;
  situacaoDescricao: string;
  analisesRegistradas: number;
  houvePendencia: boolean;
  dataSolicitacaoAnalise: string;
  dataAvaliacao: string;
}

export interface Duracao {
  segundos: number;
  precisao: 'PRECISA' | 'SOMENTE_DIA' | 'INDISPONIVEL';
  /** Pronta para a tela: `03:12:47`, `5 dias` ou `—`. */
  formatada: string;
  explicacaoDaPrecisao: string;
}

export interface EtapaAnalise {
  ordem: number;
  id: number;
  tipoAnalise: string;
  tipoAnaliseDescricao: string;
  status: string;
  observacao: string;
  anexo: string;
  hashAnexo: string;
  usuarioId: number;
  usuarioNome: string;
  instante: string;
  duracao: Duracao;
  pendencia: boolean;
}

/**
 * Análise da prestação de contas (ADR-0010).
 *
 * **Nenhum contador é somado aqui e nenhuma duração é calculada aqui.** Os cinco números e o
 * `h:m:s` chegam prontos do servidor, junto com a precisão de cada medição — é o servidor que
 * sabe quais etapas foram gravadas antes de a coluna passar a guardar hora.
 */
@Injectable()
export class AnalisePrestacaoContasService {

  url: string;

  constructor(private http: AuthHttp) {
    this.url = `${environment.apiUrl}/analise-prestacao-contas`;
  }

  /** Contadores e itens numa chamada só — contados sobre exatamente a lista devolvida. */
  resumo(celebracaoId: any): Promise<{ contadores: ContadoresAnalise, itens: ItemAnalise[] }> {
    const params = new URLSearchParams();
    params.set('celebracaoId', celebracaoId);

    return this.http.get(`${this.url}/resumo`, { search: params })
      .toPromise().then(r => r.json().dados);
  }

  /** O fluxo de aprovação de um repasse, em ordem, com o decurso de cada etapa. */
  historico(repasseId: any): Promise<EtapaAnalise[]> {
    return this.http.get(`${this.url}/historico/${repasseId}`)
      .toPromise().then(r => r.json().dados);
  }
}
